import { DEVMODE, STAGING, BACKEND_URL } from '../environment';
import { getLocaleFromDOM } from '../core/cmsIntegration';
import LoopbackProvider from '../loopback/LoopbackProvider';

export const getBaseUrl = () => {
  let additionalProdModePath = !DEVMODE && !STAGING ? '/zerpa' : '';

  const integratedLocale = getLocaleFromDOM();
  if (integratedLocale) {
    additionalProdModePath = `/${integratedLocale}/zerpa`;
  }

  return `${window.location.origin}${additionalProdModePath}`;
};

/**
 * Open path in new browser tab
 * @param {string} path - path of uri
 */
export const redirectInternalNewTab = (path) => {
  const url = `${getBaseUrl()}/${path}`;
  window.open(url, '_blank');
};

export const redirectExternalUrl = (url) => {
  window.location.href = url;
};

export const downloadFromContainer = (container, filename) => {
  window.open( // eslint-disable-line no-undef
    `${BACKEND_URL}/Containers/${container}/download/${filename}?access_token=${LoopbackProvider.loopbackToken.id}`,
    '_blank',
  );
};

export const downloadContainerUrl = (container, filename) => (
  `${BACKEND_URL}/Containers/${container}/download/${filename}?access_token=${LoopbackProvider.loopbackToken.id}`
);
